import { generateCurl, generatePython, generateTypeScript } from './codegen/curlPythonTs';
import { generateCSharp, generateGo, generateJava } from './codegen/goJavaCsharp';
import { generatePHP, generateRuby, generateSwift } from './codegen/phpRubySwift';
export { buildRedactingSubstitute, buildRequestParts } from './codegen/requestParts';
export {
  DEFAULT_CURL_OPTIONS,
  DEFAULT_PYTHON_OPTIONS,
  DEFAULT_TS_OPTIONS,
  generateCurl,
  generatePython,
  generateTypeScript,
} from './codegen/curlPythonTs';
export {
  DEFAULT_CSHARP_OPTIONS,
  DEFAULT_GO_OPTIONS,
  DEFAULT_JAVA_OPTIONS,
  generateCSharp,
  generateGo,
  generateJava,
} from './codegen/goJavaCsharp';
export {
  DEFAULT_PHP_OPTIONS,
  DEFAULT_RUBY_OPTIONS,
  DEFAULT_SWIFT_OPTIONS,
  generatePHP,
  generateRuby,
  generateSwift,
} from './codegen/phpRubySwift';

// ─── Registry ──────────────────────────────────────────────────────────────

export const CODE_GENERATORS = [
  { id: 'curl',       label: 'cURL',       fn: generateCurl },
  { id: 'python',     label: 'Python',     fn: generatePython },
  { id: 'typescript', label: 'TypeScript', fn: generateTypeScript },
  { id: 'go',         label: 'Go',         fn: generateGo },
  { id: 'java',       label: 'Java',       fn: generateJava },
  { id: 'csharp',     label: 'C#',         fn: generateCSharp },
  { id: 'php',        label: 'PHP',        fn: generatePHP },
  { id: 'ruby',       label: 'Ruby',       fn: generateRuby },
  { id: 'swift',      label: 'Swift',      fn: generateSwift },
];
